import { ABIDataTypes } from '@btc-vision/transaction';
import { BitcoinAbiTypes, BitcoinInterfaceAbi, CallResult, BaseContractProperties } from 'opnet';

// Contract address — updated after deployment
export const BITFUND_CONTRACT_ADDRESS = 'opt1sqzvvh5cukawny80lplyzaey7tztwt3un0sg4ut58';

export const BITFUND_ABI: BitcoinInterfaceAbi = [
    {
        name: 'createCampaign',
        inputs: [
            { name: 'title', type: ABIDataTypes.STRING },
            { name: 'description', type: ABIDataTypes.STRING },
            { name: 'metadata', type: ABIDataTypes.STRING },
            { name: 'goalSats', type: ABIDataTypes.UINT256 },
            { name: 'durationDays', type: ABIDataTypes.UINT16 },
            { name: 'categoryIndex', type: ABIDataTypes.UINT8 },
        ],
        outputs: [{ name: 'campaignId', type: ABIDataTypes.UINT256 }],
        type: BitcoinAbiTypes.Function,
    },
    {
        name: 'updateCampaign',
        inputs: [
            { name: 'campaignId', type: ABIDataTypes.UINT256 },
            { name: 'title', type: ABIDataTypes.STRING },
            { name: 'description', type: ABIDataTypes.STRING },
            { name: 'metadata', type: ABIDataTypes.STRING },
        ],
        outputs: [{ name: 'success', type: ABIDataTypes.BOOL }],
        type: BitcoinAbiTypes.Function,
    },
    {
        name: 'donate',
        inputs: [
            { name: 'campaignId', type: ABIDataTypes.UINT256 },
            { name: 'amount', type: ABIDataTypes.UINT256 },
        ],
        outputs: [{ name: 'success', type: ABIDataTypes.BOOL }],
        type: BitcoinAbiTypes.Function,
    },
    {
        name: 'getCampaignCount',
        inputs: [],
        outputs: [{ name: 'count', type: ABIDataTypes.UINT256 }],
        type: BitcoinAbiTypes.Function,
    },
    {
        name: 'getCampaign',
        inputs: [{ name: 'campaignId', type: ABIDataTypes.UINT256 }],
        outputs: [
            { name: 'creator', type: ABIDataTypes.UINT256 },
            { name: 'goal', type: ABIDataTypes.UINT256 },
            { name: 'raised', type: ABIDataTypes.UINT256 },
            { name: 'backers', type: ABIDataTypes.UINT256 },
            { name: 'createdAtBlock', type: ABIDataTypes.UINT256 },
            { name: 'durationDays', type: ABIDataTypes.UINT16 },
            { name: 'categoryIndex', type: ABIDataTypes.UINT8 },
            { name: 'active', type: ABIDataTypes.BOOL },
            { name: 'title', type: ABIDataTypes.STRING },
            { name: 'description', type: ABIDataTypes.STRING },
            { name: 'metadata', type: ABIDataTypes.STRING },
        ],
        type: BitcoinAbiTypes.Function,
    },
    {
        name: 'getDonationCount',
        inputs: [],
        outputs: [{ name: 'count', type: ABIDataTypes.UINT256 }],
        type: BitcoinAbiTypes.Function,
    },
    {
        name: 'getDonation',
        inputs: [{ name: 'donationId', type: ABIDataTypes.UINT256 }],
        outputs: [
            { name: 'campaignId', type: ABIDataTypes.UINT256 },
            { name: 'donor', type: ABIDataTypes.UINT256 },
            { name: 'amount', type: ABIDataTypes.UINT256 },
            { name: 'blockHeight', type: ABIDataTypes.UINT256 },
            { name: 'txHash', type: ABIDataTypes.UINT256 },
        ],
        type: BitcoinAbiTypes.Function,
    },
    {
        name: 'totalDonations',
        inputs: [],
        outputs: [{ name: 'total', type: ABIDataTypes.UINT256 }],
        type: BitcoinAbiTypes.Function,
    },
    {
        name: 'deactivateCampaign',
        inputs: [{ name: 'campaignId', type: ABIDataTypes.UINT256 }],
        outputs: [{ name: 'success', type: ABIDataTypes.BOOL }],
        type: BitcoinAbiTypes.Function,
    },
];

export interface IBitFundContract extends BaseContractProperties {
    createCampaign(
        title: string,
        description: string,
        metadata: string,
        goalSats: bigint,
        durationDays: number,
        categoryIndex: number,
    ): Promise<CallResult>;
    updateCampaign(
        campaignId: bigint,
        title: string,
        description: string,
        metadata: string,
    ): Promise<CallResult>;
    donate(campaignId: bigint, amount: bigint): Promise<CallResult>;
    getCampaignCount(): Promise<CallResult>;
    getCampaign(campaignId: bigint): Promise<CallResult>;
    getDonationCount(): Promise<CallResult>;
    getDonation(donationId: bigint): Promise<CallResult>;
    totalDonations(): Promise<CallResult>;
    deactivateCampaign(campaignId: bigint): Promise<CallResult>;
}
